import { DescriptorUpdate, updateDescriptor, updateDescriptorPublic, uploadPhotoToPresignedUrl } from '../clients/photo-upload-client';
import { ImageDescriptorData, DataUtils, ImageSubject, TeamRoles, ImageSize } from '../clients/data-service';
import { GroupBy, OrderBy } from "../utilities/DataTools";
import React from "react";
import { AddIcon, CloseIcon } from '@chakra-ui/icons'
import {
    Box,
    Button,
    Card,
    Divider,
    Image,
    HStack,
    Input,
    Select,
    SimpleGrid,
    Stack,
    Text,
    Textarea,
    VStack,
    CardBody,
    Center,
    IconButton,
    Modal,
    ModalOverlay,
    ModalBody,
    ModalContent,
    ModalHeader,
    Spinner,
    Heading
} from '@chakra-ui/react';
import { DraftImageSubject, ImageSubjectUtilities } from '../utilities/ImageSubjectUtilities';
import { PeopleUpdater } from './PeopleUpdater';
import { ImageSubjectEntry } from './ImageSubjectEntry';
import PhotoSelector from './PhotoSelector';

export interface AnnotateImageProps
{
    imageDescriptor: ImageDescriptorData;
    refreshTrigger?: () => Promise<void>;
}

export interface AnnotateImageState
{
    form: {name: string, caption? :string}
    people: Array<DraftImageSubject>
    uploadingInProgress: boolean
}




export class AnnotateImage extends React.Component<AnnotateImageProps, AnnotateImageState> {
    peopleUpdater: PeopleUpdater;

    constructor(props: AnnotateImageProps) {
        super(props);
        
        this.state = this.GenerateInitialState(props);;
        this.handleInputChange = this.handleInputChange.bind(this);
        this.save = this.save.bind(this);
        this.uploadReplacementPhoto = this.uploadReplacementPhoto.bind(this);

        const aiRef = this;
        const peopleAct = (action) => {
            aiRef.setState(prev => {
                const newState = structuredClone(prev);
                action(newState.people);
                return newState;
            });
        }
        const peopleActInPlace = (action) => {
            aiRef.setState(prev => {
                action(prev.people);
                return prev;
            });
        }
        this.peopleUpdater = new PeopleUpdater(peopleAct, peopleActInPlace);
    }

    private GenerateInitialState(props: AnnotateImageProps) : AnnotateImageState {
        const subjects = props.imageDescriptor.subjects.length > 0 ? [] : AnnotateImage.startingEmptySubjects();
        props.imageDescriptor.subjects.forEach(subject => {
            var existing = ImageSubjectUtilities.getOrAdd(subjects, subject);
            existing.name = subject.name;
            existing.role = subject.role;
        });
        
        ImageSubjectUtilities.fillGaps(subjects);
        

        const newState = {
            form: {
                name: props.imageDescriptor.name,
                caption: props.imageDescriptor.caption,
            },
            people: subjects,
            uploadingInProgress: false
        };
        return newState;
    }
    
    

    static newRow = function(rowIndex: number, count: number) : Array<DraftImageSubject> {
        const rowList: Array<DraftImageSubject> = [];
        for (var col = 1; col <= count; col++) {
            rowList.push(new DraftImageSubject(rowIndex, col, "Player"));
        }
        return rowList;
    }

    static startingEmptySubjects(rows?: number, cols?: number) : Array<DraftImageSubject> {
        const subjects: Array<DraftImageSubject> = [];
        const newRow = AnnotateImage.newRow;

        rows = rows ?? 3;
        cols = cols ?? 5;

        for (let i = rows; i > 0; i--) {
            subjects.push(...newRow(i, cols));
        }

        // subjects.push(...newRow(0, 1));
        // subjects.push(...newRow(-1, 1));

        return subjects;
    }

    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (value === "") {
            value = null;
        }
        const formField = target.name;

        this.setState((prev) => {
            const clone = structuredClone(prev.form);
            clone[formField] = value;
            return { form: clone };
        });
    }

    async save() {
        this.setState({ uploadingInProgress: true });
        const metadata : DescriptorUpdate = {
            name: this.state.form.name,
            caption: this.state.form.caption,
            subjects: ImageSubjectUtilities.draftToSubmittableSubjects(this.state.people) 
        };
        await updateDescriptor(this.props.imageDescriptor.id, metadata);
        this.setState({ uploadingInProgress: false });
    }

    async uploadReplacementPhoto(file: File) {
        this.setState({ uploadingInProgress: true });
        const newPublicResult = await updateDescriptorPublic(this.props.imageDescriptor.id);
        console.log(newPublicResult);
        const uploadResult = await uploadPhotoToPresignedUrl(newPublicResult.public_upload_url, file);
        console.log(uploadResult);
        if (this.props.refreshTrigger) {
            await this.props.refreshTrigger();
        }
        this.setState({ uploadingInProgress: false });
    }

    render() {
        const imageDetails = this.props.imageDescriptor;
        return (
            <Box p={5}>
                <Stack spacing={3}>
                    <Input type="text" placeholder="Photo Name" name="name" value={this.state.form.name} onChange={event=>this.setState(prev =>{prev.form.name = event.target.value; return prev;})} />
                    <Textarea placeholder="Photo Caption" name="caption" value={this.state.form.caption} onChange={event=>this.setState(prev =>{prev.form.caption = event.target.value; return prev;})} />
                </Stack>
                <Divider p={2} h={5} />
                <Box>
                    <Center>
                        <VStack>
                            <Heading size='md'>Original Image</Heading>
                            <Image maxH='400px' fit='contain' src={DataUtils.GetImageUrl(imageDetails.original_image, ImageSize.Full)} fallbackSrc={DataUtils.GetImageUrl(imageDetails.original_image, ImageSize.Medium)}/>
                        </VStack>
                    </Center>
                    <Divider p={2} h={5}/>
                    <Center>
                        <VStack>
                            <Heading size='md'>Refined Image</Heading>
                            <PhotoSelector onImageSelected={this.uploadReplacementPhoto} photoDesc="Refined/Better Quality Photo" />
                            {imageDetails.public_image && 
                                (<Image maxH='400px' fit='contain' src={DataUtils.GetImageUrl(imageDetails.public_image, ImageSize.Full)} fallbackSrc={DataUtils.GetImageUrl(imageDetails.public_image, ImageSize.Medium)}/>)
                            }
                        </VStack>
                    </Center>
                </Box>
                <Divider p={2} h={5}/>
                <Stack>
                    <Center>
                        <form autoComplete='off'>
                            <ImageSubjectEntry people={this.state.people} peopleUpdater={this.peopleUpdater} />
                        </form>
                    </Center>
                </Stack>
                <Divider p={2} h={5}/>
                <SimpleGrid columns={2} spacing={4}>
                            <Button  onClick={()=> this.setState(p=> this.GenerateInitialState(this.props))} >Reset</Button>
                            <Button colorScheme='green' onClick={this.save}>Save</Button>
                </SimpleGrid>
                <Modal isOpen={this.state.uploadingInProgress} onClose={() => { }} isCentered>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader textAlign='center'>
                            Saving
                        </ModalHeader>
                        <ModalBody>
                            <Center p={4}>
                                <Spinner />
                            </Center>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </Box>
        );
    }
}


